<template>
  <div class="centered-container">
    <div class="content">
    <form>
      <md-card>
        <md-card-header data-background-color="purple" style="text-align: center">
          <h4 class="title">Onboarding</h4>
          <p class="category">Noch ein paar wenige Schritte bis sie startklar sind!</p>
        </md-card-header>

        <md-card-content>
      <div>
        <md-steppers :md-active-step.sync="active">
          <md-step id="first" md-label="Customer Admin Onboarding" :md-done.sync="first">
            <div class="md-layout scroll-container">
              <div class="md-layout-item md-small-size-100 md-size-100">
                <h4>Angaben über den Admin User</h4>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-20">
                <md-field>
                  <label for="movie">Anrede</label>
                  <md-select v-model="movie" name="movie" id="movie">
                    <md-option value="fight-club">Herr</md-option>
                    <md-option value="godfather">Frau</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-40">
                <md-field>
                  <label>Vorname</label>
                  <md-input v-model="firstname" type="text"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-40">
                <md-field>
                  <label>Nachname</label>
                  <md-input v-model="lastname" type="text"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <md-field>
                  <label for="role">Funktion</label>
                  <md-select v-model="role" name="role" id="role" disabled>
                    <md-option value="admin">Verantwortliche(r) elkasy</md-option>
                    <md-option value="godfather">Systembetreuer</md-option>
                    <md-option value="godfather">IT-Ansprechpartner</md-option>
                    <md-option value="godfather">Ansprechpartner im Lager</md-option>
                    <md-option value="godfather">Rechnungsbearbeiter</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <md-field>
                  <label>Email Adresse</label>
                  <md-input v-model="emailadress" type="email"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <md-field>
                  <label>Telefonnummer</label>
                  <md-input v-model="phonenumber" type="text"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100">
                <h4>Angaben über das Unternehmen</h4>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-50">
                <md-field>
                  <label>Unternehmensname</label>
                  <md-input v-model="city" type="text"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-50">
                <md-field>
                  <label>Unternehmensstraße und Hausnummer</label>
                  <md-input v-model="country" type="text"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <md-field>
                  <label for="corporateCountry">Unternehmensland</label>
                  <md-select v-model="corporateCountry" name="corporateCountry" id="corporateCountry">
                    <md-option value="germany">Deutschland</md-option>
                    <md-option value="suiss">Schweiz</md-option>
                    <md-option value="luxembourg">Luxembourg</md-option>
                    <md-option value="austria">Österreich</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <md-field>
                  <label>Unternehmenspostleitzahl</label>
                  <md-input v-model="code" type="text"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <md-field>
                  <label>Unternehmensort</label>
                  <md-input v-model="code" type="text"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <md-field>
                  <label>Zahlungsziel</label>
                  <md-input v-model="paymentinterval" type="text" disabled></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <md-field>
                  <label>Abrechnungsintervall</label>
                  <md-input v-model="invoiceinterval" type="text" disabled></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <md-field>
                  <label>Rechnungsadresse Email</label>
                  <md-input v-model="code" type="email"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-100 text-right">
                <md-button class="md-raised md-primary" @click="setDone('first', 'second')">Weiter</md-button>
              </div>
            </div>
          </md-step>

          <md-step id="second" md-label="Lieferadresse" class="md-primary" :md-done.sync="second">
            <div class="md-layout scroll-container">
              <ShippingAddressForm
                  class="md-layout-item md-size-100"
                  title="Angaben über die Lieferadresse 1"
              />
              <ShippingAddressForm
                  class="md-layout-item md-size-100"
                  title="Angaben über die Lieferadresse 2"
              />
              <div class="md-layout-item md-size-100 text-right">
                <md-button class="md-raised md-primary" @click="setDone('second', 'third')">Weiter</md-button>
              </div>
            </div>
          </md-step>

          <md-step id="third" md-label="Weitere Benutzer" :md-done.sync="third">
            <div class="md-layout scroll-container">
              <div class="md-layout-item md-small-size-100 md-size-100">
                <h4>Angaben über weitere Benutzer</h4>
              </div>
              <div ref="container">

              </div>
              <component
                  v-for="(component, index) in addUserForms"
                  :key="index"
                  :is="component"
                  class="md-layout-item md-size-100"
              />
              <div class="md-layout-item md-size-100 text-right">
                <md-button class="md-raised md-primary" @click="addAdditionalUserForm">
                  <md-icon>add</md-icon>
                </md-button>
              </div>
              <div class="md-layout-item md-size-100 text-right">
                <md-button class="md-raised md-primary">Fertig</md-button>
              </div>
            </div>
          </md-step>
        </md-steppers>
      </div>
        </md-card-content>
      </md-card>
    </form>
    <div class="background"></div>
    </div>
  </div>
</template>

<script>
import ShippingAddressForm from "../components/Onboarding/ShippingAddressForm";
import AddUserForm from "../components/Onboarding/AddUserForm";
import Vue from "vue";
export default {
  name: "Onboarding",
  components: {AddUserForm, ShippingAddressForm},
  data: () => ({
    initial: 'Initial Value',
    type: null,
    paymentinterval: "14-tägig",
    invoiceinterval: "monatlich",
    hasShippingAdress: false,
    corporateCountry: "germany",
    shippingCountry: "germany",
    requireAccount: false,
    role: "admin",
    active: 'first',
    first: false,
    second: false,
    third: false,
    addUserForms: []
  }),
  methods: {
    setDone (id, index) {
      this[id] = true;

      if (index) {
        this.active = index;
      }
    },
    addAdditionalUserForm() {
      let AddUserFormClass = Vue.extend(AddUserForm);
      let instance = new AddUserFormClass({
        propsData: {
          delete: this.deleteUserForm
        }
      });

      instance.$mount();
      this.$refs.container.appendChild(instance.$el)
      this.addUserForms.push(instance);
    },
    deleteUserForm(form) {
      let index = this.addUserForms.indexOf(form);

      if (index !== -1) {
        this.addUserForms.splice(index, 1);
      }
    }
  },
  created() {
    this.addAdditionalUserForm();
  }
}
</script>

<style scoped>
.centered-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100vh;
}
.content {
  width: 100%;
  max-width: 1000px;
  height: 100%;
  max-height: 700px;
}
.scroll-container {
  max-height: 450px;
  overflow-y: auto;
}
.background {
  background-image: url("../assets/img/landing_page_background.jpg");
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 0;
}
.md-content {
  z-index: 1;
  width: 100%;
  height: 100%;
  max-width: 1000px;
  max-height: 600px;
  position: relative;
  padding: 0;
}

</style>
